module.exports = __webpack_public_path__ + "fonts/iconfont.7a192085.ttf";